import React from "react";
import { useDispatch } from "react-redux";
import { Flex, Button } from "ui-components";
import { getMyInfoAuthorisedURL } from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";
import Logo from "assets/images/singpass_logo.png";
import LogoWhite from "assets/images/singpass_logo_white.png";
import { getButtonColorVariant, buttonThemes } from "ui-components/theme";
import styles from "./styles";
import { setData } from "ducks/actions";

const MyInfoBox = ({
  title,
  btnLabel,
  fieldNameToClear,
  clearInfoLabel,
  setMyInfoIsUsed,
  clearMyInfoFormFields,
  clearMyInfoUrlParam,
  clearMyInfoDomain,
  myInfoIsUsed,
  appSettings
}) => {
  const link = getMyInfoAuthorisedURL(appSettings);
  const dispatch = useDispatch();

  const handleOnloginWithMyInfoClick = () => {
    dispatch(setData({ key: "MyInfoEvent" }));
  };

  const onClearButtonClicked = () => {
    clearMyInfoUrlParam();
    clearMyInfoFormFields(fieldNameToClear);
    clearMyInfoDomain();
    setMyInfoIsUsed(false);
  };

  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      pt={3}
      pb={2}
    >
      <Flex
        width="100%"
        alignItems={"center"}
        justifyContent={"center"}
        textAlign={"center"}
        sx={styles.title}
      >
        {title && (
          <div>
            <FormattedMessage html id={title} values={{ logo: Logo }} />
          </div>
        )}
      </Flex>

      {myInfoIsUsed ? (
        <Button
          variant="primary"
          sx={getButtonColorVariant(buttonThemes?.singpass)}
          onClick={onClearButtonClicked}
        >
          <FormattedMessage
            html
            id={clearInfoLabel || "my_info_clear_info_button"}
            values={{ logo: LogoWhite }}
          />
        </Button>
      ) : (
        <Button
          variant="primary"
          sx={getButtonColorVariant(buttonThemes?.singpass)}
          as="a"
          href={link}
          onClick={handleOnloginWithMyInfoClick}
        >
          <FormattedMessage
            html
            id={btnLabel || "my_info_retrieve_button"}
            values={{ logo: LogoWhite }}
          />
        </Button>
      )}
    </Flex>
  );
};

MyInfoBox.defaultProps = {
  fieldNameToClear: [],
  btnLabel: "my_info_retrieve_button",
  clearInfoLabel: "my_info_clear_info_button"
};

export default MyInfoBox;
